import { inject as D, ref as w, reactive as y, nextTick as E, watchEffect as R, toRefs as U } from "vue";
import { I as x } from "./helper-BIBe7yYh.js";
const p = Symbol.for("torusui:display"), C = {
  thresholds: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
  }
};
function v(o) {
  return x && !o ? window.innerWidth : 0;
}
function g(o) {
  return x && !o ? window.innerHeight : 0;
}
function j(o = C) {
  return { install: (d) => {
    const A = (r) => {
      const { thresholds: t } = o, a = w(g(r)), n = y({}), s = w(v(r));
      function h() {
        a.value = g(), s.value = v();
      }
      return r && E(() => h()), R(() => {
        const e = s.value < t.sm, l = s.value < t.md && !e, i = s.value < t.lg && !(l || e), u = s.value < t.xl && !(i || l || e), m = s.value < t.xxl && !(u || i || l || e), c = s.value >= t.xxl;
        n.xs = e, n.sm = l, n.md = i, n.lg = u, n.xl = m, n.xxl = c, n.smAndUp = !e, n.mdAndUp = !(e || l), n.lgAndUp = !(e || l || i), n.xlAndUp = !(e || l || i || u), n.smAndDown = !(i || u || m || c), n.mdAndDown = !(u || m || c), n.lgAndDown = !(m || c), n.xlAndDown = !c, n.height = a.value, n.width = s.value;
      }), x && window.addEventListener("resize", h, { passive: !0 }), U(n);
    }, { mount: f } = d;
    d.mount = (r, t, a) => {
      d.provide(p, A(t));
      const n = f(r, t, a);
      return d.mount = f, n;
    };
  } };
}
function z() {
  const o = D(p);
  if (!o) throw new Error("Could not find display injection");
  return o;
}
export {
  j as createDisplay,
  z as useDisplay
};
//# sourceMappingURL=display.esm.js.map
